import { SearchScenarioId, getScenarioStore } from "owa-search-store";
import { SuggestionKind } from "owa-search-service";
import type { PeopleSuggestion } from "owa-search-service";

export interface SelectedFromPeoplePill {
    readonly id: string;
    readonly suggestion: PeopleSuggestion;
    readonly emailAddresses: string[];
}

function normalizeEmailAddress(emailAddress: unknown): string | undefined {
    if (typeof emailAddress === "string") {
        return emailAddress;
    }
    
    if (emailAddress && typeof emailAddress === "object" && "EmailAddress" in emailAddress) {
        const value = emailAddress.EmailAddress;
        return typeof value === "string" ? value : undefined;
    }
    
    return undefined;
}

export default function getSelectedFromPeoplePills(): SelectedFromPeoplePill[] {
    const store = getScenarioStore(SearchScenarioId.Mail);
    return store.suggestionPillIds.reduce<SelectedFromPeoplePill[]>((selectedPeople, id) => {
        const suggestion = store.suggestionPills.get(id);
        if (suggestion?.kind === SuggestionKind.People && suggestion.CustomQueryText?.FromKql) {
            const emailAddresses = (suggestion.EmailAddresses ?? []).reduce<string[]>((addresses, emailAddress) => {
                const normalizedAddress = normalizeEmailAddress(emailAddress);
                if (normalizedAddress) {
                    addresses.push(normalizedAddress);
                }
                return addresses;
            }, []);
            selectedPeople.push({ id, suggestion, emailAddresses });
        }
        return selectedPeople;
    }, []);
}
